import React from 'react'
import "./index.less"

function CategoryName(props) {
    const { category, selected, style, className, onClick, fontSize, iconWrapperStyle, contentWrapperStyle, color, hideIcon, selectedBorder } = props;
    return (
        <div onClick={onClick} className={`category-name`} style={style}>
            {/* {(!hideIcon) && <div className="icon-wrapper" style={iconWrapperStyle}>
                <i className="fa fa-circle" style={{ fontSize: "8px", lineHeight: "20px", color: color }}></i>
            </div>} */}
            <div className={`content-wrapper ${(className) ? className : ""} ${(selected && selectedBorder) ? "selected" : ""}`} style={contentWrapperStyle}>
                <span style={{
                    color: ((category?.tantsevalnayaDistsiplinaPsevdonim && category?.tantsevalnayaDistsiplinaPsevdonim != category?.tantsevalnayaDistsiplina?.nazvanie) ||
                        (category?.kategoriyaUchastnikovPsevdonim && category?.kategoriyaUchastnikovPsevdonim != category?.kategoriyaUchastnikov?.nazvanie)) ? "rgba(0, 0, 0, 0.25)" : "rgba(0,0,0,.85)"
                }}>
                    <span style={(selected) ? { fontWeight: "600", paddingRight: "10px" } : { paddingRight: "10px" }}>
                        <span style={(selected) ? {} : { fontStyle: "italic" }}>{category?.tantsevalnayaDistsiplina?.nazvanie}</span>
                        <span> - </span>
                        <span style={(selected) ? { fontWeight: "600" } : {}}>{category?.kategoriyaUchastnikov?.nazvanie}</span>
                    </span>
                </span>
                {((category?.tantsevalnayaDistsiplinaPsevdonim && category?.tantsevalnayaDistsiplinaPsevdonim != category?.tantsevalnayaDistsiplina?.nazvanie) ||
                    (category?.kategoriyaUchastnikovPsevdonim && category?.kategoriyaUchastnikovPsevdonim != category?.kategoriyaUchastnikov?.nazvanie)) && <span>
                        <i className="fa fa-angle-double-right"></i>
                        <span style={(selected) ? { fontWeight: "600", paddingLeft: "10px" } : { paddingLeft: "10px" }}>
                            <span style={(selected) ? {} : { fontStyle: "italic" }}>{category?.tantsevalnayaDistsiplinaPsevdonim}</span>
                            <span> - </span>
                            <span style={(selected) ? { fontWeight: "600" } : {}}>{category?.kategoriyaUchastnikovPsevdonim}</span>
                        </span>
                    </span>}
            </div>
        </div>
    )
}

export default CategoryName